import React, { useState } from "react";
import { StyledBannerInfo } from "./styles";
const BannerInfo = ({ children, theme }) => {
  return <StyledBannerInfo>{children}</StyledBannerInfo>;
};

export default BannerInfo;
